module.exports = __webpack_public_path__ + "static/media/spaced-rep.9851e325.png";